import CallToActionContainer, { CallToActionContainerProps } from '@/components/common/callToAction/CallToActionContainer';

import styles from './ModalHeadlineV2.module.scss';

export type ModalHeadlineV2Props = {
  buttonLeft?: CallToActionContainerProps;
  buttonRight?: CallToActionContainerProps;
  title?: string;
};

const ModalHeadlineV2 = ({ buttonLeft, buttonRight, title }: ModalHeadlineV2Props): React.JSX.Element => {
  const headlineClassName = [
    styles.headline,
    buttonLeft && buttonRight && styles['two-icons'],
    buttonLeft && !buttonRight && styles['left-icon']
  ].filter(Boolean).join(' ');

  return (
    <>
      <div className={headlineClassName} data-test-id="headline">
        {buttonLeft && (
          <CallToActionContainer
            icon={{
              url: buttonLeft.icon?.url,
              alt: buttonLeft.icon?.alt,
              height: buttonLeft.icon?.height || 24,
              width: buttonLeft.icon?.width || 24
            }}
            onClick={buttonLeft.onClick}
            kind={buttonLeft.kind}
            fullWidthOnMobile={false}
            type="button"
          />
        )}

        {buttonRight && (
          <CallToActionContainer
            icon={{
              url: buttonRight.icon?.url,
              alt: buttonRight.icon?.alt,
              height: buttonRight.icon?.height || 24,
              width: buttonRight.icon?.width || 24
            }}
            onClick={buttonRight.onClick}
            kind={buttonRight.kind}
            fullWidthOnMobile={false}
            type="button"
          />
        )}
      </div>

      {title && <div className={styles.title}>{title}</div>}
    </>
  );
};

export default ModalHeadlineV2;
